import React from 'react';
import { Row, Col, Input, Button, Popover } from 'antd';
import { connect } from 'dva';
import env from '../../lib/env';

class Header extends React.Component {
    constructor(...props) {
        super(...props);
        this.state = {
            value: props[0].search.query,
            showImg: false,
            showOut: false,
            iframeSrc: null,
        }
    }

    goto_collect = () => {
        env.goto_page('/user/bookrack');
    }

    logout = () => {
        this.props.dispatch({ type: 'user/logout' });
    }

    changeHandler(e) {
        this.setState({
            value: e.target.value
        })
    }

    handleHover = () => {
        this.setState({
            showImg: true
        })
    }

    handleOut = () => {
        this.setState({
            showImg: false
        })
    }

    handleHoverButton = () => {
        this.setState({
            showOut: true
        })
    }

    handleOutButton = () => {
        this.setState({
            showOut: false
        })
    }

    try_wx_login = () => {
        window.location.href = `//libs.wandu.cn/user/wx_login_page?from=${encodeURIComponent(window.location.href)}`;
    }

    try_qq_login = () => {
        window.location.href = `//libs.wandu.cn/user/qq_login_page?from=${encodeURIComponent(window.location.href)}`;
    }

    render() {
        return (
            <div>
                <div style={{ background: '#E6FBD2' }}>
                    <div style={{ width: '1000px', margin: '0 auto', position: 'relative' }}>
                        <Row type="flex" justify="space-between" align="middle" style={{
                            height: '74px'
                        }}>
                            <Col>
                                <img alt="" src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ width: '150px' }} />
                            </Col>
                            {/* <Col>
                                <Input.Search
                                    placeholder="透视之眼"
                                    enterButton="搜索"
                                    value={this.state.value}
                                    onChange={this.changeHandler.bind(this)}
                                    onSearch={value => this.props.dispatch({
                                        type: 'search/query',
                                        payload: value,
                                    })}
                                    style={{
                                        width: '452px',
                                    }}
                                />
                            </Col> */}
                            {/* <Col className={styles.header_control}>
                                {!this.props.user.user_id &&
                                    <section>
                                        <img onClick={this.try_qq_login} className={styles.login_icon} src={qq_icon} alt="" />
                                        <img onClick={this.try_wx_login} className={styles.login_icon} src={weixin_icon} alt="" />
                                        <Popover content={(
                                            <div className={styles['qrcode-wrapper']}>
                                                <div className={styles['android']}>
                                                    <div className={styles['qrcode-img']}>
                                                        <img src="https://img.wandu.cn/novel/cover/2024/andriod_qrcode.png" alt="" />
                                                    </div>
                                                    <div className={styles['text']}>Android下载</div>
                                                </div>
                                                <div className={styles['ios']}>
                                                    <div className={styles['qrcode-img']}>
                                                        <img src="https://img.wandu.cn/novel/cover/2024/ios_qrcode.png" alt="" />
                                                    </div>
                                                    <div className={styles['text']}>IOS下载</div>
                                                </div>
                                            </div>
                                        )}>
                                            <a style={{ color: '#FFFFFF', paddingLeft: '10px', fontSize: '17px' }} href='https://img.wandu.cn/fe/pc_download/download.html' target='_blank'>下载APP</a>
                                        </Popover>
                                    </section>
                                }
                            </Col> */}
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

const state_props = state => {
    return {
        user: state.user,
        search: state.search,
    }
}

export default connect(state_props)(Header);



// WEBPACK FOOTER //
// ./src/layout/app/header.js